import React, { useEffect, useState } from 'react'
import { useConnection } from './hooks/useConnection'

export const MainContext = React.createContext({
  filters: {},
  setFilters: () => {},
  width: 0,
  isDesktop: false,
  setScrollY: () => {},
  pageScrollY: 0,
  setConfigVars: () => {},
  configVars: {},
  offersData: [],
  isError: false,
  isLoading: false,
  pagesTotal: 0,
  hasNextPage: false,
  setCurrentTab: () => {},
  currentTab: {}
})

export const MainContextProvider = ({ children }) => {
  const [filters, setFilters] = useState({
    category: [],
    popularity: undefined,
    rating: undefined,
    price: undefined,
    name: undefined,
    pagination: 1,
    offerType: undefined,
    priceLevel: undefined,
    businessType: undefined,
    predicateName: undefined,
    fetchData: true
  })
  const [width, setWidth] = useState()
  const [isDesktop, setDesktop] = useState()
  const [pageScrollY, setScrollY] = useState(0)
  const [currentTab, setCurrentTab] = useState()
  const [configVars, setConfigVars] = useState({
    env: undefined,
    skin: undefined,
    geo: undefined,
    uuid: undefined,
    fiid: undefined
  })
  const [offersData, setOffersData] = useState([])

  const { apiConnection, isSuccess, data, isError, isLoading } = useConnection(
    configVars.env
  )

  const updateWindowDimensions = () => {
    setWidth(window.innerWidth)
    setDesktop(window.innerWidth > 991 ? 'desktop' : 'mobile')
  }

  const uberEatsIncludedInFilters = (filters) => {
    return (
      (filters.name &&
        uberEatsObject.name
          .toLowerCase()
          .includes(filters.name.toLowerCase())) ||
      !filters.name
    )
  }

  const uberEatsObject = {
    business_type: {
      type: 'ecommerce',
      url: ''
    },
    venue: {
      _id: ' ',
      name: 'Uber Eats',
      status: 'active',
      business_type: 'ecommerce'
    },
    name: 'Uber Eats',
    status: 'active',
    price_level: 0,
    popularity: 0,
    socialMedia: [],
    media:
      'https://assets.reworth.app/processed/TestMau_2023-06-15-09:25:16_small.jpeg',
    dv_category: 'Alimentos y bebidas',
    raw_category: 'food-beverages',
    dv_address: ' ',
    dv_latlng: [],
    cashback_decimal: 0.15,
    dv_cashback: '15%',
    expires: null,
    created: 1635174721,
    dv_name: 'Uber Eats',
    opening_hours: {},
    rules: {
      quick_type: 'recurring'
    }
  }

  useEffect(() => {
    setWidth(window.innerWidth)
    setDesktop(window.innerWidth > 991 ? 'desktop' : 'mobile')
    window.addEventListener('resize', updateWindowDimensions)
  }, [])

  useEffect(() => {
    apiConnection({ ...configVars, ...filters })
  }, [filters, configVars])

  useEffect(() => {
    if (isSuccess && data?.data.length > 0) {
      const formatBusinessnameForFilter = data?.data.map((item) => {
        return {
          ...item,
          name: item.name.split('-')[0].trim()
        }
      })

      const filteredDataGeneral = formatBusinessnameForFilter.filter((item) => {
        // this Items should not be visible for any other FI except Coppel
        // as theyre exclusive for bancoppel integration (Comercios exclusivos para Coppel)
        return (
          item?.name !== 'Uber Eats' &&
          item?.name !== 'Dentalia' &&
          item?.name !== 'Servifacil' &&
          item?.name !== 'CLIVI DIABETES' &&
          item?.name !== 'Caffenio' &&
          item?.name !== 'Cabanna' &&
          item?.name !== 'The Italian Coffee Culiacán' &&
          item?.name !== 'The Italian Coffee' &&
          item?.name !== 'Beis Shop' &&
          item?.name !== 'Carmela Restaurante' &&
          item?.name !== 'Carmela'
        )
      })

      const filteredDataCoppel = formatBusinessnameForFilter?.filter((item) => {
        // This item must NO be visible for Bancoppel
        return (
          item?.name !== 'Hertz-Avasa' &&
          item?.name !== '99minutos.com' &&
          item?.name !== 'Bodega Aurrera' &&
          item?.name !== 'Bodega aurrera' &&
          item?.name !== 'Chilpa' &&
          item?.name !== 'chilpa' &&
          item?.name !== 'Cielito Querido Café' &&
          item?.name !== 'Kura' &&
          item?.name !== 'Decathlon' &&
          item?.name !== 'El Asturiano' &&
          item?.name !== 'GASOL' &&
          item?.name !== 'GG' &&
          item?.name !== 'Open English' &&
          item?.name !== 'Take a Wok' &&
          item?.name !== 'Teikit' &&
          item?.name !== 'Tiendas Neto' &&
          item?.name !== 'Tierra Garat' &&
          item?.name !== 'PlayDoit' &&
          item?.name !== 'Saint'
        )
      })

      // Set every FI to consume the filteredDataGeneral except Coppel and Reworth
      if (configVars.skin === 'CLARA') {
        if (uberEatsIncludedInFilters(filters)) {
          setOffersData([...filteredDataGeneral, uberEatsObject])
        } else {
          setOffersData([...filteredDataGeneral])
        }
      } else if (configVars.skin === 'COPPEL') {
        setOffersData(filteredDataCoppel)
      } else if (configVars.skin === 'REWORTH') {
        setOffersData(data.data)
      } else {
        setOffersData(filteredDataGeneral)
      }
    } else {
      if (configVars.skin === 'CLARA' && uberEatsIncludedInFilters(filters)) {
        setOffersData([uberEatsObject])
      } else {
        setOffersData([])
      }
    }
  }, [isSuccess, data])

  useEffect(() => {
    if (filters.name !== undefined) setCurrentTab()
  }, [filters.name])

  const pagesTotal = data?.pages
  const hasNextPage = data?.hasNextPage

  return (
    <MainContext.Provider
      value={{
        filters,
        setFilters,
        width,
        isDesktop,
        pageScrollY,
        setScrollY,
        setConfigVars,
        configVars,
        pagesTotal,
        hasNextPage,
        offersData,
        isError,
        isLoading,
        setCurrentTab,
        currentTab
      }}
    >
      {children}
    </MainContext.Provider>
  )
}
